var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "club-summary" },
    [
      _c("div", { staticClass: "club-summary__title-wrap" }, [
        _c("h2", { staticClass: "club-summary__title" }, [
          _vm._v("\n      Клубная программа\n    ")
        ]),
        _vm.IS_EMPLOYEE
          ? _c("div", { staticClass: "club-summary__employee-state" }, [
              _vm._v("\n      " + _vm._s(_vm.LEVEL_NAME) + "\n    ")
            ])
          : _vm._e()
      ]),
      _c("div", { staticClass: "club-summary__card-wrap-outter" }, [
        _c(
          "div",
          { staticClass: "club-summary__card-wrap" },
          [
            _c("f-sprite-icon", {
              staticClass: "club-summary__card",
              attrs: { "icon-link": _vm.$options.icons.ImageCard.id }
            }),
            _c("div", { staticClass: "club-summary__card-id-title" }, [
              _vm._v("\n        Номер клубной карты\n      ")
            ]),
            _c("div", { staticClass: "club-summary__card-id" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.USER_BONUS_CARD_NUMBER) + "\n      "
              )
            ])
          ],
          1
        )
      ]),
      _c("div", { staticClass: "club-summary__points-wrap" }, [
        _c("div", { staticClass: "club-summary__points-title" }, [
          _vm._v("\n      Доступно\n    ")
        ]),
        _c("div", { staticClass: "club-summary__points" }, [
          _vm._v("\n      " + _vm._s(_vm._f("price")(_vm.BONUSES)) + " "),
          _c("span", { staticClass: "club-summary__points-caption" }, [
            _vm._v(
              _vm._s(_vm._f("decl")(_vm.BONUSES, "бонус", ["", "а", "ов"]))
            )
          ])
        ])
      ]),
      _c("div", { staticClass: "club-summary__detalization" }, [
        !_vm.IS_EMPLOYEE
          ? _c("div", [
              _c("div", { staticClass: "club-summary__detalization-caption" }, [
                _vm._v("\n        из них\n      ")
              ]),
              _c(
                "div",
                { staticClass: "club-summary__detalization-inner" },
                [
                  _c("club-points-detail", {
                    staticClass: "club-summary__detalization-item",
                    attrs: {
                      tooltip:
                        "Начисляются за покупку товара, на который не установлена и не применена скидка",
                      "is-promotion": false,
                      title: "за покупки",
                      date: _vm.CASHBACK_BONUS.expireAt,
                      points: _vm.CASHBACK_BONUS.amount || 0,
                      "points-burns": _vm.CASHBACK_BONUS.expiringAmount || 0
                    }
                  }),
                  _c("club-points-detail", {
                    staticClass: "club-summary__detalization-item",
                    attrs: {
                      tooltip:
                        "Начисляются в период специальных акций в объёме, оговорённом в условиях акций",
                      "is-promotion": "",
                      title: "за покупки",
                      points: _vm.totalPromoBonuses,
                      date: _vm.promoFirstEnds.dateEnd || "",
                      "points-burns": _vm.promoFirstEnds.bonuses || 0
                    }
                  })
                ],
                1
              )
            ])
          : _c(
              "div",
              [
                _vm.IS_EMPLOYEE
                  ? _c("club-summary-burns", {
                      attrs: {
                        points: _vm.promoFirstEnds.bonuses || 0,
                        date: _vm.promoFirstEnds.dateEnd || ""
                      }
                    })
                  : _vm._e()
              ],
              1
            )
      ]),
      _c(
        "div",
        { staticClass: "club-summary__info" },
        [
          _c("ui-link", { attrs: { href: "/fun-club" } }, [
            _vm._v("\n      Программа лояльности\n    ")
          ]),
          _vm._v(
            " FUNDAY дает участникам специальные привилегии,\n    дополнительные скидки и уникальные предложения.\n  "
          )
        ],
        1
      ),
      _c("phone-edit", { staticClass: "club-summary__phone-edit" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }